import { useTranslation } from "react-i18next";
import { EmailLogin } from "./EmailLogin";

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-4 grid h-full place-items-center">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-2 pb-4">
          <h1>{t("login.title")}</h1>
        </div>
        <div className="space-y-4">
          <EmailLogin />
        </div>
      </div>
    </div>
  );
};

